import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  chip: {
    fontWeight: 600,
    textTransform: 'uppercase',
  },
  linkCell: {
    color: theme.palette.info.main,
    cursor: 'pointer',
  },
}))

export default styles
